import { CategoryFolderEnum } from '@shared/enums/categorie.enum';
import { OrderByEnum } from '@shared/models/common/orderby.enum';
import { RechercheColonneEnum } from '@shared/enums/recherche-colonne.enum';
export class MesRemboursemntsRechercheForm {
  constructor(
    public numeroDossier?: string,
    public numeroFacture?: string,
    public dateDebutDemande?: Date,
    public dateFinDemande?: Date,
    public dateDecision?: Date,
    public rechercheBySiret: boolean = false,
    public siret?: string,
    public statutDossier?: string,
    public statutDossierLabel?: string,
    public decision: string = '=',
    public decisionLabel: string = 'est égale',
    public categorieDossier: CategoryFolderEnum = CategoryFolderEnum.TOUTES,
    public page: number = 0,
    public nbElement?: number,
    public orderBy?: OrderByEnum,
    public orderByColumn?: RechercheColonneEnum,
    public typeDispositif?: string,
    public typeDispositifLibelle?: string
  ) {}
}


